@let order = order$ | async;
@let productInCartCount = (cartProducts$ | async)?.length ?? 0;
@let orderValidationInProgress = orderValidationInProgress$ | async;

<div
  class="flex flex-col gap-4 border-t-6 p-5"
  [style.borderColor]="primaryButtonBackgroundColor | contentBuilderColor"
>
  <ng-container *ngIf="errorMessages">
    <p
      class="my-5 rounded bg-error-50 px-8 py-6 font-base text-3xl text-error-700"
      *ngFor="let message of errorMessages"
    >
      {{ message }}
    </p>
  </ng-container>
  <div class="flex flex-row justify-between text-right">
    <div class="flex flex-row items-center">
      <div class="text-4xl font-bold">{{ 'kiosk-footer-cart.your-order' | translate }}</div>
      <div class="ml-2 text-4xl font-bold">
        {{ productInCartCount }}
        {{
          productInCartCount === 1
            ? ('kiosk-footer-cart.item-singular' | translate)
            : ('kiosk-footer-cart.item-plural' | translate)
        }}
      </div>
    </div>
    <div class="flex flex-row items-center">
      <p class="mr-2 text-4xl font-bold">{{ 'kiosk-footer-cart.total' | translate }}</p>
      <div class="relative text-4xl font-bold">
        <div
          [class.invisible]="!orderValidationInProgress"
          class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        >
          <p class="mx-auto h-5 w-28 animate-pulse rounded bg-neutral-400 px-4"></p>
        </div>
        <div [class.invisible]="orderValidationInProgress">
          <app-price-atom
            [format]="true"
            [amount]="order?.final_price && productInCartCount ? (order?.final_price ?? 0) : 0"
            size="4XL"
          ></app-price-atom>
        </div>
      </div>
    </div>
  </div>

  <app-kiosk-horizontal-scroll
    [leftButtonTemplate]="leftButton"
    [rightButtonTemplate]="rightButton"
    [contentTemplate]="content"
    #horizontalScroll
  >
    <ng-template #leftButton>
      @let leftButtonData = horizontalScroll.leftButtonData;
      <app-button-atom
        size="S"
        color="neutral"
        [icon]="'icon-arrow-down-s'"
        [iconRotation]="'180'"
        type="kiosk-light"
        thickSize="S"
        [full]="false"
        [aspectSquare]="true"
        [disabled]="leftButtonData().disabled"
      ></app-button-atom>
    </ng-template>

    <ng-template #rightButton>
      @let rightButtonData = horizontalScroll.rightButtonData;
      <app-button-atom
        size="S"
        color="neutral"
        [icon]="'icon-arrow-down-s'"
        [iconRotation]="'270'"
        type="kiosk-light"
        thickSize="S"
        [full]="false"
        [disabled]="rightButtonData().disabled"
        [aspectSquare]="true"
      ></app-button-atom>
    </ng-template>

    <ng-template #content>
      <div>
        @if (!(reconstructedShareOrderBasket$ | async)?.length) {
          @let cartByShop = reconstructedCart$ | async;
          @if (cartByShop && cartByShop.length) {
            <div>
              @for (cart of cartByShop; track $index) {
                <div class="max-width-full flex flex-row">
                  <ul
                    class="flex flex-1 flex-row gap-8 pt-2.5"
                    #productList
                  >
                    @for (
                      product of cart[reconstructedCartKeys.Items];
                      let index = $index;
                      track $index
                    ) {
                      <li>
                        <app-kiosk-product-overview-cart-atom
                          [id]="product[reconstructedCartItemKeys.Item][cartItemKeys.Id]"
                          [name]="product[reconstructedCartItemKeys.Product][productKeys.Name]"
                          [quantity]="
                            product[reconstructedCartItemKeys.Item][cartItemKeys.Quantity]
                          "
                          [thumbnail]="
                            product[reconstructedCartItemKeys.Product].images?.thumbnail?.url
                          "
                          [dotColor]="primaryButtonBackgroundColor"
                          [dotTextColor]="primaryButtonTextColor"
                          [productBackgroundColor]="productBackgroundColor"
                          [productTextColor]="productTextColor"
                          [isAvailable]="
                            !(unAvailableProductById()?.[product.item.item_id] ?? false)
                          "
                          [hasProductToReplace]="
                            product.item.item_id
                              | appFn
                                : mustReplaceAComposedProduct
                                : cart[reconstructedCartKeys.Items]
                                : unAvailableProductById()
                          "
                          (click)="onUpdateItem(product.item.id)"
                        ></app-kiosk-product-overview-cart-atom>
                      </li>
                    }
                  </ul>
                </div>
              }
            </div>
          }
        }
      </div>
    </ng-template>
  </app-kiosk-horizontal-scroll>

  <div
    class="mt-8 grid grid-cols-2 gap-10"
    [class.hidden]="hideButtons()"
  >
    <app-button-atom
      size="XXL"
      thickSize="XXL"
      [label]="'kiosk-footer-cart.cancel' | translate"
      [overrideBgColor]="secondaryButtonBackgroundColor"
      [overrideTextColor]="secondaryButtonTextColor"
      type="kiosk-light"
      (click)="clearCart()"
      [full]="true"
    ></app-button-atom>
    <app-button-atom
      size="XXL"
      [label]="'kiosk-footer-cart.continue-to-cart' | translate"
      thickSize="XXL"
      [overrideBgColor]="primaryButtonBackgroundColor"
      [overrideTextColor]="primaryButtonTextColor"
      [disabled]="!order?.final_price || productInCartCount === 0"
      type="kiosk-primary"
      (click)="navigateToCart()"
      [full]="true"
    ></app-button-atom>
  </div>
</div>
